
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g6b9hcwZcn1Rt4yP_45O_4WXB1GsJSXwb7t59WvTHnYPt4Meta } from "/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexI4r5MmszKQEQ71X5HHGe4pjpb9eTb9_Wgl897M05dC8Meta } from "/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchtysms2XxpDp2sU8EcWplt1DsORgw1_D3KQ_45ZekcYLhgMeta } from "/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexnRCFr2LyuwlTe95N1ROLC0zt0SNCcJ62hdD1A2Fgs78Meta } from "/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93HyNiK_G60yCHfEULc6S0jFsuufBOXM0t3y_QMHVP93wMeta } from "/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexbWwBuMGj_cX31enGLzcmDO_45dMFnfQSpgkOULyk2ljxkMeta } from "/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93MnmfPn8gQiWvfrDVE1gy67sNRgY6FHP9OodiuXlJhTcMeta } from "/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexsH_J_7j3y6Mdwd7QVgOj3OyhoSfTxLBv93807hNNn2UMeta } from "/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_930cCKv5iSmzSWgYWLBFqZaaTNINQOroVFoj22d7rizqQMeta } from "/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexFscvOAMkX1rkSIEqnfUc4DBmLbTOB6i9a9_JlLUZwJgMeta } from "/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexMiO9zDs4qTtbks5x4HgFmfjB9ddPKvW2TbpH1CmVfAAMeta } from "/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexbWwBuMGj_cX31enGLzcmDO_45dMFnfQSpgkOULyk2ljxkMeta || {},
    component: () => import("/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexsH_J_7j3y6Mdwd7QVgOj3OyhoSfTxLBv93807hNNn2UMeta || {},
    component: () => import("/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexFscvOAMkX1rkSIEqnfUc4DBmLbTOB6i9a9_JlLUZwJgMeta || {},
    component: () => import("/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexMiO9zDs4qTtbks5x4HgFmfjB9ddPKvW2TbpH1CmVfAAMeta || {},
    component: () => import("/codebuild/output/src814072554/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]